import { ResourcesConfig } from "aws-amplify";

// Environment detection
const getEnvironment = (): "production" | "development" => {
  const apiUrl = process.env.REACT_APP_API_URL || "";
  const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN || "";

  // Explicit environment variable takes precedence
  if (process.env.REACT_APP_ENVIRONMENT === "dev") {
    return "development";
  }

  // Auto-detect from API URL or Cognito domain
  if (
    apiUrl.includes("-dev-") ||
    apiUrl.includes("/dev") ||
    cognitoDomain.includes("-dev-")
  ) {
    return "development";
  }

  return "production";
};

export const environment = getEnvironment();
export const isDevelopment = environment === "development";

export const config = {
  // Google Maps API Key
  googleMapsApiKey:
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "YOUR_GOOGLE_MAPS_API_KEY",

  // Mapbox API Key
  mapboxToken: process.env.REACT_APP_MAPBOX_TOKEN || "",

  // AWS Configuration
  aws: {
    region: process.env.REACT_APP_REGION || "us-east-1",
    userPoolId: process.env.REACT_APP_USER_POOL_ID || "",
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || "",
    identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID || "",
    graphqlEndpoint: process.env.REACT_APP_GRAPHQL_ENDPOINT || "",
    cognitoDomain: process.env.REACT_APP_COGNITO_DOMAIN || "",
  },

  // App configuration
  app: {
    name: "Campaign Manager",
    defaultCenter: {
      lat: parseFloat(process.env.REACT_APP_MAP_CENTER_LAT || "36.0057967"),
      lng: parseFloat(process.env.REACT_APP_MAP_CENTER_LNG || "-86.8858226"),
    },
    defaultZoom: parseFloat(process.env.REACT_APP_MAP_DEFAULT_ZOOM || "12"),
  },
};

// Amplify configuration
export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: config.aws.userPoolId,
      userPoolClientId: config.aws.userPoolWebClientId,
      loginWith: {
        oauth: {
          domain: `${config.aws.cognitoDomain}.auth.${config.aws.region}.amazoncognito.com`,
          scopes: [
            "openid",
            "email",
            "profile",
            "aws.cognito.signin.user.admin",
          ],
          redirectSignIn: [window.location.origin],
          redirectSignOut: [window.location.origin],
          responseType: "code",
        },
      },
    },
  },
  API: {
    GraphQL: {
      endpoint: config.aws.graphqlEndpoint,
      region: config.aws.region,
      defaultAuthMode: "userPool",
    },
  },
};
